import React, { useState, useContext, useEffect } from 'react';
import RichText from '../rich-text';
import context from '../../context/product/context';
import CookieConsent from 'react-cookie-consent';
import Button from '../button';

const CookieBanner = () => {
	const ctxt = useContext(context);
	const { accept, decline } = ctxt.json.pages.cookies;
	const [selected, setSelected] = useState<string>('');
	const [display, setDisplay] = useState<boolean>(false);

	useEffect(() => {
		updateCookie();
	}, []);

	const updateCookie = () => {
		const name = 'InterestBasedAds=';
		const cDecoded = decodeURIComponent(document.cookie);
		const cArr = cDecoded.split('; ');
		const res = cArr
			.find((cookie) => cookie.includes(name))
			?.substring(name.length);
		if (!res) {
			setDisplay(true);
		} else {
			setSelected(res);
		}
	};

	return (
		<div
			id="cookiebanner"
			className="fixed w-full bottom-0 left-0 z-50 font-novartis">
			<div className="z-10 w-full fixed left-0 bottom-0 h-10 bg-novartis-blue py-2.5 lg:w-0 lg:h-0 lg:border-r-[100px] lg:border-r-transparent lg:border-b-[100px] lg:border-b-novartis-blue lg:bg-transparent">
				<Button
					data-testid="cookiebtn"
					className="w-full h-10 flex flex-col justify-center items-center text-sm text-center text-white font-bold fixed left-0 bottom-0 lg:w-20 lg:text-left lg:m-1.5 lg:mb-2"
					onClick={() => {
						setDisplay(true);
					}}>
					<RichText html={ctxt.json.pages.cookies.interestBasedAds} />
				</Button>
			</div>
			{display && (
				<CookieConsent
					flipButtons
					location="bottom"
					declineButtonText={decline}
					hideOnAccept={true}
					buttonText={accept}
					cookieName="InterestBasedAds"
					cookieValue="accept"
					declineCookieValue="decline"
					visible={'show'}
					enableDeclineButton={true}
					disableStyles={true}
					disableButtonStyles={true}
					containerClasses="w-full fixed bottom-0 bg-white [&_a]:text-novartis-blue p-4 flex flex-col items-center mb-10 lg:mb-0 lg:h-[100px] lg:pl-28 lg:flex-row lg:justify-center shadow-leap"
					buttonClasses={`bg-novartis-blue rounded py-2 px-11 text-sm text-white lg:py-2.5 hover:underline ${
						selected === 'accept' ? 'font-bold underline' : ''
					}`}
					declineButtonClasses={`bg-[#F1F1F1] rounded py-2 px-11 text-sm text-zinc-800 lg:py-2.5 hover:underline ${
						selected === 'decline' ? 'font-bold underline' : ''
					}`}
					buttonWrapperClasses="flex w-full justify-between md:justify-center md:gap-8 lg:max-w-sm"
					onAccept={() => {
						setDisplay(false);
						updateCookie();
					}}
					onDecline={() => {
						setDisplay(false);
						updateCookie();
					}}>
					<div
						data-testid="cookietext"
						className="max-w-4xl text-xs text-zinc-800 pb-4 lg:pb-0">
						<p className="pb-2">
							<RichText html={ctxt.json.pages.cookies.privacy} />
						</p>
						<p>
							<RichText html={ctxt.json.pages.cookies.advertising} />
						</p>
					</div>
				</CookieConsent>
			)}
		</div>
	);
};

export default CookieBanner;
